import React, { useState } from "react";

import { fireOnce } from "@ds-developer/frontend";

import { useAuth, useTealium } from "@hubcapp/context";

import { StateProviderProps } from "./types";
import LessonNotesModal from "./LessonNotesModal";
import useMutationUpdateLesson from "./hooks/useMutationUpdateLesson";

const LessonNotesModalStateProvider: React.FC<StateProviderProps> = ({
  handleCancel = () => {},
  learnerId,
  lessonId,
  value,
}) => {
  const {
    instructor: { id: instructorId },
  } = useAuth();
  const [notes, setNotes] = useState(value);
  const [submitting, setSubmitting] = useState<boolean>(false);

  const [updateNotes] = useMutationUpdateLesson(instructorId, learnerId);
  const { trackEvent } = useTealium();

  const deleteNotes = async () => {
    trackEvent({
      eventCategory: "View Learner - Lesson History",
      eventAction: "Button Click",
      eventLabel: "Delete",
    });
    setSubmitting(true);
    await updateNotes({
      variables: {
        id: lessonId,
        notes: "",
      },
      optimisticResponse: {
        __typename: "Mutation",
        updateLesson: {
          id: lessonId,
          notes: "",
        },
      },
    });
    setSubmitting(false);
  };

  const saveNotes = async () => {
    trackEvent({
      eventCategory: "View Learner - Lesson History",
      eventAction: "Button Click",
      eventLabel: "Save",
    });
    setSubmitting(true);
    await updateNotes({
      variables: {
        id: lessonId,
        notes,
      },
      optimisticResponse: {
        __typename: "Mutation",
        updateLesson: {
          id: lessonId,
          notes,
        },
      },
    });
    setSubmitting(false);
  };

  const handleCancelTest = () => {
    trackEvent({
      eventCategory: "View Learner - Lesson History",
      eventAction: "Button Click",
      eventLabel: "Cancel",
    });
    handleCancel();
  };

  const handleNotes = () => {
    fireOnce("View Learner - Lesson History|Interaction|Notes", () => {
      trackEvent({
        eventCategory: "View Learner - Lesson History",
        eventAction: "Interaction",
        eventLabel: "Notes",
      });
    });
  };

  return (
    <LessonNotesModal
      handleCancel={handleCancelTest}
      handleChange={e => {
        setNotes(e.target.value);
      }}
      handleDelete={() => {
        deleteNotes();
        handleCancel();
      }}
      handleSubmit={e => {
        e.preventDefault();
        saveNotes();
        handleCancel();
      }}
      value={notes}
      open
      submitting={submitting}
      handleNotes={handleNotes}
    />
  );
};

export default LessonNotesModalStateProvider;
